import $ from "jquery";
function replaceWithContent($element, content) {
    const $replacement = $(content);
    $element.replaceWith($replacement);
    return $replacement;
}
export { replaceWithContent };
